import { css } from 'aphrodite';
import type { ReactNode } from 'react';
import { ChevronDown } from '../../../../../components/svgs/icons/ChevronDown';
import { ChevronUp } from '../../../../../components/svgs/icons/ChevronUp';
import { InfoIcon } from '../../../../../components/svgs/icons/InfoIcon';
import { SimpleTooltip, TooltipProvider } from '../../../../../components/Tooltip';
import { Button } from '../../../../../components-v2/Button';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { styleSheet } from './styles';

export const SECTION_ROW_LIMIT = 3;

type IProps = {
	title: string;
	count: number;
	titleHint?: string;
	actions?: ReactNode;
	itemNoun?: string;
	isExpanded?: boolean;
	onExpandedChange?: (isExpanded: boolean) => void;
	children: ReactNode;
};

export const FilesSection = ({
	title,
	count,
	titleHint,
	actions,
	itemNoun,
	isExpanded = false,
	onExpandedChange,
	children,
}: IProps) => {
	const canExpand = !!itemNoun && !!onExpandedChange && count > SECTION_ROW_LIMIT;

	return (
		<section className={css(styleSheet.sectionCard)} aria-label={title}>
			<div className={css(styleSheet.sectionHeader)}>
				<div className={css(styleSheet.sectionHeading)}>
					<h3 className={css(styleSheet.sectionTitle)}>{title}</h3>
					<span className={css(styleSheet.sectionCount)}>{count}</span>
					{titleHint && (
						<TooltipProvider>
							<SimpleTooltip title={titleHint} styles={[styleSheet.sectionHintTooltip]}>
								<Button variant='ghost' size='icon' aria-label={`About ${title}`} styles={[styleSheet.sectionHint]}>
									<InfoIcon fillColor={THEME.colors.icon.gray} />
								</Button>
							</SimpleTooltip>
						</TooltipProvider>
					)}
				</div>
				{actions && <div className={css(styleSheet.sectionActions)}>{actions}</div>}
			</div>
			{children}
			{canExpand && (
				<div className={css(styleSheet.sectionFooter)}>
					<Button variant='ghost' size='sm' aria-expanded={isExpanded} onClick={() => onExpandedChange(!isExpanded)}>
						{isExpanded ? <ChevronUp /> : <ChevronDown />}
						{isExpanded ? 'Show fewer' : `Show all ${count} ${itemNoun}`}
					</Button>
				</div>
			)}
		</section>
	);
};
